import { appConfig } from "@/helpers/appConfig";

// Единый источник базы API. Порядок разрешения (resolveApiBase), сверху вниз:
//   1) VRT-оверрайд из localStorage 'vrt_api_base' — только same-origin путь
//      (напр. /vrt-api). Playwright заставляет ТОТ ЖЕ прод-бандл ходить в VRT-БД.
//   2) appConfig("VUE_APP_API_URL") — рантайм-конфиг (вариант 3): window.__APP_CONFIG__
//      из app-config.<hash>.js на стенде → затем зашитый на build .env (локалка).
//      См. docs/runtime-config.md.
//   3) '/api' — относительный same-origin фолбэк для стендов: фронт и /api за одним
//      ingress на одном origin. Страховка от регресса «в бандле undefined → /undefined/...».
function resolveApiBase() {
  try {
    const override = window.localStorage.getItem("vrt_api_base");
    // Безопасность: только относительный same-origin путь ("/vrt-api").
    // Блокируем "//host", "http://host" и пустое значение.
    if (override && /^\/[^/]/.test(override)) {
      return override;
    }
  } catch (e) {
    // localStorage недоступен — тихо откатываемся на дефолт.
  }
  return appConfig("VUE_APP_API_URL", "/api");
}

export const API_URL = resolveApiBase();
